import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { CloseIcon } from './atoms';
import { BorderedImage, BorderedVideo, Empty } from 'atoms';
import { FileSvg } from 'components/icons';

const template = styled.div`
  position: relative;
  margin-left: 20px;
  margin-bottom: 9px;
`;

export default Molecule({
  template,
  atoms: [
    {
      component: CloseIcon,
      name: 'CloseIcon',
      displayValue: ({ }) => 'x',
    },
    {
      component: BorderedImage,
      name: 'Image',
      renderIf: ({ src }) => src?.includes('image'),
      displayValue: ({ src }) => src,
      displayState: ({ }) => ({ width: '35px', height: '35px' })
    },
    {
      component: BorderedVideo,
      name: 'Image',
      renderIf: ({ src }) => src?.includes('video'),
      displayValue: ({ src }) => src,
      displayState: ({ }) => ({ width: '35px', height: '35px' })
    },
    {
      component: Empty,
      name: 'Image',
      renderIf: ({ src }) => !src?.includes('video') && !src?.includes('image'),
      displayValue: ({ }) => FileSvg({ width: '35px', height: '35px' }),
    },
  ]
})
